import React from "react";
import { Card, CardBody, Container } from "reactstrap";

const EmailValidationResult = ({ isValidatedEmail }) => {
  return (
    <React.Fragment>
      <div className="bg-soft-light min-vh-100">
        <div className="p-4">
          <Container fluid={true}>
            <div className="row">
              <div className="col-md-4 offset-md-4">
                <Card>
                  <CardBody>
                    {isValidatedEmail ? (
                      <div className="text-center p-4">
                        <i className="far fa-check-circle fs-1 text-success"></i>
                        <p className="py-2">
                          El correo electrónico ha sido verificado
                        </p>
                      </div>
                    ) : (
                      <div className="text-center p-4">
                        <i className="far fa-sad-tear fs-1"></i>
                        <p className="py-2">
                          Ocurrió un problema al verificar el correo electrónico
                        </p>
                      </div>
                    )}
                  </CardBody>
                </Card>
              </div>
            </div>
          </Container>
        </div>
      </div>
    </React.Fragment>
  );
};

export default EmailValidationResult;
